Ext.define('SA.data.DataModel', {
    singleton: true,

    canResolveGeographicRelease({attribute, attributes = [attribute], location}) {
        var getAttributeRelease = attribute => SA.data.AttributesCache.get(attribute).geographicRelease,
            locationReleases = SA.data.LocationsCache.getGeographicReleases(location);

        return attributes.every(attribute => locationReleases.includes(getAttributeRelease(attribute)));
    },

    canResolveGeographicUnit({attribute, attributes, location}) {
        return SA.data.GeographicUnits.getAllowedIds({attribute, attributes, location}).length > 0;
    },

    getAllowedGeoUnitsForRanking({location, attributes, geoUnitsFilter}) {
        if (!location || attributes.length === 0) {
            return [];
        }

        var locationUnits = SA.data.GeographicUnits.getAllowedIdsForLocation(location),
            attributeUnits = Ext.Array.union(...attributes.map(attribute => SA.data.GeographicUnits.getAllowedIdsForAttribute(attribute))),
            units = SA.data.GeographicUnits.find({
                units: Ext.Array.intersect(locationUnits, attributeUnits),
                maximum: SA.data.LocationsCache.getGeographicUnit(location),
                includeCountry: true
            }).filter(unit => geoUnitsFilter.includes(unit.geographicUnit));

        if (location === 'usa:place:3651000') {
            return Ext.Array.insert(units, 1, [SA.data.GeographicUnits.get('usa:county')]);
        }

        return units;
    },

    getDatasetsWithNoMatchingUnitsForLocation({location, attributes}) {
        var locationUnits = SA.data.GeographicUnits.getAllowedIdsForLocation(location),
            getAttributeUnits = attribute => SA.data.GeographicUnits.getAllowedIdsForAttribute(attribute),
            attributeHasNoMatchingUnits = attribute => !SA.Array.overlaps(locationUnits, getAttributeUnits(attribute)),
            getDataset = attribute => SA.data.AttributesCache.get(attribute).dataset_series,
            datasets = attributes.filter(attributeHasNoMatchingUnits).map(getDataset);

        return SA.Array.unique(datasets);
    },

    noAttributeInLocationGeographicReleases({location, attributes}) {
        var location = SA.data.LocationsCache.get(location),
            attributes = SA.data.AttributesCache.get(attributes),
            isAttributeInLocationGeographicReleases = (attribute, location) => location.geographicReleases.includes(attribute.geographicRelease),
            hasAtLeastOneAttributeInGeographicReleases = location => attributes.some(attribute => isAttributeInLocationGeographicReleases(attribute, location)),
            locations;

        if (!location || attributes.length === 0) {
            return false;
        }

        if (location.type === 'combination') {
            locations = location.locationSeries.map(locationId => SA.data.LocationsCache.get(locationId));
        }
        else if (location.type === 'radius') {
            locations = [SA.data.LocationsCache.get(location.locationSeries)];
        }
        else {
            locations = [location];
        }

        return !locations.some(hasAtLeastOneAttributeInGeographicReleases);
    }
});